<template>
  <div class="detail-container">
    <el-page-header @back="goBack"/>

    <el-card v-loading="loading">
      <el-descriptions title="订单详情" :column="2" border>
        <template #title>
          <span>订单详情</span>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-chat-dot-round"
            @click="handleChat"
            style="margin-left: 20px"
          >
            在线沟通
          </el-button>
        </template>
         <el-descriptions-item label="产品名称">{{ detailData.cropName }}</el-descriptions-item>
        <el-descriptions-item label="类型">
          <el-tag :type="detailData.type === 2 ? 'success' : 'warning'">
            {{ detailData.type === 2 ? '供应' : '求购' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="价格">{{ detailData.price }}</el-descriptions-item>
        <el-descriptions-item label="数量">{{ detailData.num }} {{ detailData.unit }}</el-descriptions-item>
        <el-descriptions-item label="交货地址">{{ detailData.address }}</el-descriptions-item>
        <el-descriptions-item label="产品说明">{{ detailData.memo }}</el-descriptions-item>
        <el-descriptions-item label="产品图片">
          <el-image
            v-for="(img, index) in previewList"
            :key="index"
            :src="img.url"
            :preview-src-list="previewList"
            class="image-thumb"
          />
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detailData.createTime }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import { getSupplyOrderDetail } from '@/api/supplyOrder';
import { getStore } from "@/js/utils/store";
import { mapGetters } from "vuex";
import { SendMessage } from "@/api/websocket.js";
export default {
  data() {
    return {
      baseUrl: window.globalUrl.HOME_API,
      loading: false,
      detailData: {},
      previewList: []
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname", "identityObj"]),
  },
  methods: {
    async loadData() {
      try {
        this.loading = true
        const { id } = this.$route.query
        const res = await getSupplyOrderDetail({ id })
        this.detailData = res.data
        console.log(res.data, 'res.data')
        if (res.data.img && JSON.parse(res.data.img).length > 0) {
          this.previewList = JSON.parse(this.detailData.img).map(item => ({ ...item, url: this.baseUrl + 'admin/file/get?ossFilePath=' + item.url }))
        }

      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    async handleChat() {
       let token = getStore({ name: "access_token" });
        if (!token) {
          this.$router.push({ name: "login" });
          this.$message.error("用户凭证已过期");
          return;
        }
        console.log(this.detailData);
        if (this.detailData.identityId == this.identityObj.identityId) {
          this.$message.info("本人项目");
          return;
        } else {
          let params = {
          messageList: [
            {
              //消息类型会话托管
              messageType: 17,
            },
          ],
          receiverId: this.detailData.identityId,
          senderType: this.identityObj.identityTypeCode,
          //接受消息人类型只有公司认证用户
          receiverType: this.detailData.identityType,
          senderId: this.identityObj.identityId,
          sender: this.identityObj.realName,
          receiver: this.detailData.userName,
        };
        let res = await SendMessage(params);
        if (res.code == 0) {
          console.log(this.$router, "发送成功");
          this.$router.push({
            path: "/home/Chat",
            query: {
              isshow: true, // 你要传递的参数
              data: this.detailData,
              num: 17,
            },
          });
        }
        }
    }
  }
}
</script>

<style scoped>
.detail-container {
  height: 70vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.el-card {
  flex: 1;
  margin-top: 20px;
  overflow: auto;
}
.image-thumb {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

</style>
